"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get AppBar if you don\'t pass any props. ' +
    'It have white as its default background color and the toggle drawer icon is gray.';
var code = "import React from 'react';\nimport { AppBar } from 'jsc-react-ui';\n\nconst AppBarExample = () => <AppBar />;";
exports.RawExampleAppBar = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.AppBar, null))); };
exports.RawExampleAppBar.displayName = 'RawExampleAppBar';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentAppBarPage/RawExampleAppBar.tsx
// module id = 629
// module chunks = 0